<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$t('components.service.modal.HistoryFilter.1') }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="d-flex flex-column gap-3 mb24">
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.2') }}</div>
                <SelectSimple
                    id="typelocal"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.12')"
                    :keywords="this.directionList"
                    :isFilterSelect="true"
                    :hotUpdate="true"
                    :dataValue="this.fields.typelocal"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.3') }}</div>
                <SelectSimple
                    id="done"
                    :keywords="this.statusList"
                    :hotUpdate="true"
                    :isFilterSelect="true"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.13')"
                    :dataValue="this.fields.done"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.4') }}</div>
                <div class="d-flex align-items-center gap-2">
                    <SelectSimple
                        id="pre_sum"
                        :keywords="this.amountTypeList"
                        :hotUpdate="true"           
                        :defaultValue="this.$t('components.service.modal.HistoryFilter.14')"
                        :dataValue="this.fields.pre_sum"
                        @updateParentState="this.updateState"
                    />
                    <InputSimple
                        id="sum"
                        :placeholder="this.$t('components.service.modal.HistoryFilter.15')"
                        :dataValue="this.fields.sum"
                        @updateParentState="this.updateState"
                        :regCheck="{f: (num) => {
                           return this.$lib.summValidate(num)
                        }}"
                        @focusout="handleFocusOut()"
                    />
                </div>
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.5') }}</div>
                <InputSimple
                    id="transact_num"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.16')"
                    :dataValue="this.fields.transact_num"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.6') }}</div>
                <SelectSimple
                    id="code"
                    :keywords="this.operationTypeList"
                    :hotUpdate="true"
                    :isFilterSelect="true"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.17')"
                    :dataValue="this.fields.code"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="d-flex align-items-center mb8">
                    <div class="fsp14 lh20 neue-roman">{{ this.$t('components.service.modal.HistoryFilter.7') }}</div>
                    <Popper :hover="true">
                        <Icon name="info" size="c16" class="ml4" />
                        <template #content>
                            <label class="neue-roman fsp14 text-white">{{ this.$t('components.service.modal.HistoryFilter.20') }}</label>
                        </template>
                    </Popper>
                </div>
                <InputSimple
                    id="param"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.18')"
                    :dataValue="this.fields.param"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.8') }}</div>
                <InputSimple
                    id="ext_transact_num"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.16')"
                    :dataValue="this.fields.ext_transact_num"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="d-flex align-items-center justify-content-between">
                    <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.9') }}</div>
                    <div class="menu-bg fsp14 lh20 neue pointer text-decoration-underline" @click="this.fields.keyt = false">
                        {{ this.$t('components.service.modal.HistoryFilter.21') }}
                    </div>
                </div>
                <SelectSimple
                    id="keyt"
                    :hotUpdate="true"
                    :keyt="true"
                    :isSearch="true"
                    :keywords="this.$store.getters.get_keyts_keywords"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.19')"
                    :dataValue="this.fields.keyt"
                    @updateParentState="this.updateState"
                />
            </div>
            <div v-if="this.$store.state.userData.passport_serial[0] == 'Service-Member'" class="d-flex align-items-center gap-3 justify-content-between">
                <div class="fsp14 lh20 neue-roman">{{ this.$t('views.History.58') }}</div>
                <SwitchSimple
                    :dataValue="this.fields.show_in_member_accounting_curr" 
                    id='show_in_member_accounting_curr' 
                    @updateParentState="this.updateState"
                />
            </div>
        </div>
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">{{ $t('components.service.modal.HistoryFilter.10') }}</Button>
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.HistoryFilter.11') }}</Button>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';
import Button from '@/components/service/Button.vue';
import InputSimple from '../InputSimple.vue';
import SelectSimple from '../SelectSimple.vue';
import Popper from '../Popper.vue';
import SwitchSimple from '@/components/service/SwitchSimple.vue';

export default {
    components: {
        Icon,
        Button,
        SelectSimple,
        InputSimple,
        Popper,
        SwitchSimple
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            callback: null,
            defaultFields: {},
            fields: {
                typelocal: false,
                done: '',
                sum: '',
                transact_num: '',
                code: '',
                param: '',
                ext_transact_num: '',
                keyt: false,
                show_in_member_accounting_curr: false,
                pre_sum: '=',
                invoice_payments: false,
            },
            statusList: [
                {'code': '1', value: this.$t('views.History.41')},
                {'code': '0,4', value: this.$t('views.History.42')},
                {'code': '-2,-3,3,5', value: this.$t('views.History.43')}
            ],
            directionList: [
                {'code': '1', value: this.$t('views.History.32')},
                {'code': '2', value: this.$t('views.History.33')},
            ],
            amountTypeList: [
                {'code': '=', value: this.$t('views.History.34')},
                {'code': '<>', value: this.$t('views.History.35')},
                {'code': '>', value: this.$t('views.History.36')},
                {'code': '>=', value: this.$t('views.History.37')},
                {'code': '<', value: this.$t('views.History.38')},
                {'code': '<=', value: this.$t('views.History.39')},
            ],
            operationTypeList: [
                {'code': '89401,89403,51113,51120,53103', value: this.$t('views.History.50')},
                {'code': '51013,51043', value: this.$t('views.History.24')},
                {'code': '52013,52023,52063', value: this.$t('views.History.25')},
                {'code': '50123', value: this.$t('views.History.27')},
                {'code': '16401', value: this.$t('views.History.52')},
                {'code': '82200,82205,82210', value: this.$t('views.History.61')},
                {'code': '72011', value: this.$t('views.History.62')},
                {'code': 'invoice', value: this.$t('views.History.65')},
                //{'code': '53103', value: this.$t('views.History.29')}, 
                {'code': '-89401,-89403,-51113,-51013,-51120,-53103,-51043,-52013,-52023,-52063,-50123,-16401,-82200,-82205,-82210,-72011', value: this.$t('views.History.30')},
            ],
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        save() {
            this.callback(this.fields);
            this.close();
        },
        clearAll() {
            this.fields = { ...this.defaultFields };
        },
        handleFocusOut() {
            if((this.fields.pre_sum == '=' || this.fields.pre_sum == '<' || this.fields.pre_sum == '<=') && Number(this.fields.sum) == 0) {
                this.fields.sum = '';
            }
        },
        updateState(state) {
            this.fields[state.id] = state.value;
            if(state.id == 'code') {
                if(state.value == 'invoice') {
                    this.fields.invoice_payments = '1'
                } else if(state.value == this.operationTypeList[this.operationTypeList.length - 1].code) {
                    this.fields.invoice_payments = '0'
                } else {
                    this.fields.invoice_payments = ''
                }
            } else if(state.id == 'pre_sum') {
                if(state.value == '=' || state.value == '<' || state.value == '<=' && Number(this.fields.sum) == 0) {
                    this.fields.sum = '';
                }
            }
        }
    },
    created() {
        this.defaultFields = Object.assign({}, { ...this.fields, pre_sum: '=' });
        this.fields = this.$store.state.modal.content.fields;
        if(!this.fields.pre_sum) {
            this.fields.pre_sum = '=';
        }
        this.callback = this.$store.state.modal.content.callback;
    }
}
</script>